/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerPlay = createReactComponent("player-play", "IconPlayerPlay", [
  ["path", { d: "M7 4v16l13 -8z", key: "svg-0" }]
]);

export { IconPlayerPlay as default };
//# sourceMappingURL=IconPlayerPlay.js.map
